/**
 * Timetable jQuery Plugin to display a week view of a timetable
 *
 * Copyright 2013 51cg
 *
 * @author Ian J Robotham <i.robotham@abdn.ac.uk>
 */

(function ($) {
    // "use strict";

    // Define some vars for holding settings and calculated values
    var settings = null;
    var dimensions = null;

    // Define the number of timeblocks this event spans
    var eventtimeblockspans = null;
    var drawntimeblocks     = null;
    var drawntimeblockscols = null;

    // Define some vars for holding jQuery objects
    var container = null;
    var container_timetable_panel = null;

    // Plugin definition
    $.fn.timetable = function (method) {
        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        }

        if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        }

        $.error('Method ' +  method + ' does not exist on jQuery.' + plugin_name);
    };

    // Define the defaults
    $.fn.timetable.defaults = {
        // Id prefix for the panels
        idprefix: 'timetable',

        // Loading image
        loadingimage: 'assets/dist/img/ajax-loader.gif',

        // Container for the event data (JSON)
        events: null,

        // URL for event data
        eventsurl: '',
        templateurl: '',

        // Data information
        dpy: 0,
        datastart: dayjs().subtract(1, 'month'),
        dataend: dayjs().add(1, 'month'),

        // Week start & end dates
        startdt: null,
        enddt: null,

        // Daily start/end times
        daystart: 0,
        dayend: 24,

        // Start DOW & days to display
        weekstart: 1,
        daysdisplayed: 5,

        // Format for the day header
        daydateformat: 'ddd D MMMM',

        // Time block increments
        gridincrements: 60,
        timeblockheight: 60,

        // Event handlers
        onClick: null,
        onDrag: null,

        // Container injection
        headerInject: null,
    };

    // Publicly accessible methods.
    var methods = {
        init: function (options) {
            // Extend our default options with those provided.
            // Note that the first arg to extend is an empty object -
            // This is to keep from overriding our "defaults" object.
            settings = $.extend({}, $.fn.timetable.defaults, options);

            // Assign the parent container
            container = this;

            // Check & set the start date/time
            if (settings.startdt === null) {
                settings.startdt = dayjs().startOf('week');
            }

            // Is the start date the same as our weekly start?
            var currday = dayjs(settings.startdt).day();
            if (currday !== settings.weekstart) {
                settings.startdt = dayjs(settings.startdt).day(settings.weekstart - currday);
            }

            // Check & set the end date/time
            if (settings.enddt === null) {
                settings.enddt = dayjs(settings.startdt).add(settings.daysdisplayed - 1, 'day');
            }

            settings.weekOneMonth = 8; // August

            // Calculate the dimensions
            dimensions = {
                day: {
                    width: Math.round(100 / settings.daysdisplayed),
                },
            };

            // Draw the Grid
            drawGrid();

            // Toggle visibility of loading screen (show it!)
            _toggleLoader('show');

            // Check if we have events or if we need to load them
            if (settings.events === null && settings.eventsurl !== null) {
                loaddata(settings.eventsurl);
            } else {
                // We already had events so draw them
                drawEvents();
            }

            // Bind on swipe events
            container.bind('swipeleft', function () {
                move(7);
            });
            container.bind('swiperight', function () {
                move(-7);
            });
        },
        refreshTimetable: function () {
            $('.timetable-event').remove();
            var requesturl = settings.templateurl.replace('%%DPY%%', settings.dpy)
                .replace('%%LOCATION%%', settings.location)
                .replace('%%START%%', dayjs(settings.datastart).format('X'))
                .replace('%%END%%', dayjs(settings.dataend).format('X'))
                .replace('%%UID%%', settings.uid ? settings.uid : '');

            renderHeaderText();
            loaddata(requesturl);
        },
        changeDate: function (datestr) {
            var newdate = dayjs(datestr).startOf('week');

            // Is the start date the same as our weekly start?
            var currday = newdate.day();
            if (currday !== settings.weekstart) {
                newdate = dayjs(newdate).day(settings.weekstart - currday);
            }

            // Move to the new dates
            move(newdate.diff(settings.startdt, 'day'));
        },
        changeDegreeYear: function (dpy) {
            $('.timetable-event').remove();
            // Change the dpy setting that is used to make up the request URL
            settings.dpy = dpy;

            var requesturl = settings.templateurl.replace('%%DPY%%', settings.dpy)
                .replace('%%START%%', dayjs(settings.datastart).format('X'))
                .replace('%%END%%', dayjs(settings.dataend).format('X'))
                .replace('/%%UID%%', '');

            renderHeaderText();
            // Request the data and draw it
            loaddata(requesturl);
        },
        changeUserView: function (uid) {
            $('.timetable-event').remove();
            // Change the user id setting that is used to make up the request URL
            settings.uid = uid;
            settings.dpy = 0;

            var requesturl = settings.templateurl.replace('%%DPY%%', 0)
                .replace('%%START%%', dayjs(settings.datastart).format('X'))
                .replace('%%END%%', dayjs(settings.dataend).format('X'))
                .replace('%%UID%%', settings.uid);

            renderHeaderText();
            // Request the data and draw it
            loaddata(requesturl);
        },
        loadData: loaddata,
    };

    /**
     * Loads event data from the specified URL
     *
     * @param {string} url the URL containing the JSON formatted data
     *
     * @returns {undefined}
     */
    function loaddata(loadurl) {
        $.ajax({
            type: 'GET',
            url: loadurl,
            beforeSend: function () {
                // Put up a nice loading screen
                _toggleLoader('show');
            },
            success: function (events) {
                settings.events = events;
                drawEvents();
            },
            error: function (jqXHr, textStatus, errorThrown) {
                // Error handler if AJAX request failed
                console.error(textStatus, errorThrown);
            },
            complete: function () {
                // Hide the loading screen when the request has finished
                _toggleLoader('hide');
            },
        });
    }

    // #####################################################################################################################
    //                                              Drawing Methods
    // #####################################################################################################################
    /**
     * Draws the background grid
     *
     * @returns {undefined}
     */
    function drawGrid() {
        // Add the parent divs to the container
        $('body').append('<div id="' + settings.idprefix + '-loader" class="timetable-loader">' +
            '<div class="loaderimage">' +
            '<i class="' + FontAwesome.prefix('solid', 'arrows-rotate', true) + ' fa-5x"></i><br>' +
            '<span>Loading&hellip;</span>' +
            '</div>' +
            '</div>');
        container.append('<div id="' + settings.idprefix + '-centre-pane" class="timetable-centre-pane">' +
            '<div id="' + settings.idprefix + '-header" class="timetable-header">' +
            '<a id="' + settings.idprefix + '-previous" class="timetable-navigation pull-left" title="Previous Week"><i class="' + FontAwesome.prefix('solid', 'arrow-left') + '"></i></a>' +
            '<div id="' + settings.idprefix + '-header-text"></div>' +
            '<a id="' + settings.idprefix + '-next" class="timetable-navigation pull-right" title="Next Week"><i class="' + FontAwesome.prefix('solid', 'arrow-right') + '"></i></a>' +
            '</div>' +
            '<div class="' + settings.idprefix + '-categories"></div>' +
            '<div id="' + settings.idprefix + '-panel" class="timetable-panel"></div>' +
            '</div>');

        // Inject the header extra if we have it
        if (settings.headerInject !== null) {
            $('#' + settings.idprefix + '-header').append($(settings.headerInject));
        }
        renderHeaderText();

        // Add the header & content row
        $('#' + settings.idprefix + '-panel').append('<div id="' + settings.idprefix + '-header-row" class="timetable-header-row"/>');
        $('#' + settings.idprefix + '-panel').append('<div id="' + settings.idprefix + '-content-row" class="timetable-content-row" />');

        // Add the timeblock column
        $('#' + settings.idprefix + '-content-row').append('<div id="' + settings.idprefix + '-timeblock-header" class="timetable-timeblock-header" />');

        // Add the timetable inner - a.k.a. the grid
        $('#' + settings.idprefix + '-content-row').append('<div id="' + settings.idprefix + '-timetable-inner" class="timetable-timeblock-inner"  />');
        container_timetable_panel = $('#' + settings.idprefix + '-timetable-inner');

        // Draw the header rows
        $('#' + settings.idprefix + '-header-row').append('<div class="timetable-timeblock">&nbsp;</div>');
        $('#' + settings.idprefix + '-header-row').append('<div id="' + settings.idprefix + '-header-columns" class="timetable-header-columns" />');
        var headerrow = $('#' + settings.idprefix + '-header-columns');
        for (var d = 0; d < settings.daysdisplayed; d++) {
            // Draw the day
            headerrow.append('<div id="' + settings.idprefix + '-day-' + d + '" class="timetable-day" style="width:' + dimensions.day.width + '%" />');
        }
        // Add the dates to the day headers
        renderDayHeaderText();

        // Draw the all day events content slot
        $('#' + settings.idprefix + '-all-day-row').append('<div id="' + settings.idprefix + '-all-day-content" class="timetable-all-day-content" style="min-height: ' + settings.timeblockheight / 2 + 'px" />');

        // Draw the time slots
        var timeblockheader = $('#' + settings.idprefix + '-timeblock-header');

        for (var h = settings.daystart; h <= settings.dayend; h++) {
            var time = dayjs().tz('Europe/London').hour(h).minute(0);

            // Add the output
            timeblockheader.append(
                '<div class="timetable-timeblock" style="height: ' + settings.timeblockheight + 'px">' +
                time.format('h:mm') +
                '<span class="timetable-ampm">' + time.format('A') + '</span>' +
                '</div>'
            );
        }

        // Draw the grid blocks
        for (var i = 0; i < settings.daysdisplayed; i++) {
            // Create the day column
            container_timetable_panel.append('<div id="' + settings.idprefix + '-day-column-' + i + '" class="timetable-day-column" style="width:' + dimensions.day.width + '%" />');
            container_timetable_panel.append('<div id="' + settings.idprefix + '-day-event-column-' + i + '" class="timetable-day-event-column" style="width:' + dimensions.day.width + '%; left: ' + i * dimensions.day.width + '%" />');

            // Grab day column
            var daycol = $('#' + settings.idprefix + '-day-column-' + i);

            // Create the day
            for (var j = settings.daystart; j <= settings.dayend; j++) {
                // Add the output
                daycol.append('<div class="timetable-timeblock " style="height: ' + settings.timeblockheight + 'px" />');
            }
        }

        $('.timetable-content-row').slimScroll({
            height: 'auto',
        });

        // Set the scroll bar
        $('.timetable-content-row').slimScroll({
            scrollTo: '540px',
        });

        $('.timetable-content-row').slimScroll().bind('slimscrolling', function (e, pos) {
            var scrollYPos = pos;
        });

        // Add action listeners onto next/prev
        $('#' + settings.idprefix + '-previous').on('click', function () {
            move(-7);
            // Set the scroll bar to 09:00
            $('.timetable-content-row').slimScroll({
                scrollTo: '540px',
            });
        });

        $('#' + settings.idprefix + '-next').on('click', function () {
            move(7);
            // Set the scroll bar to 09:00
            $('.timetable-content-row').slimScroll({
                scrollTo: '540px',
            });
        });
    }

    /**
     * This function handles the rendering of a 'go to' link that will scroll the timetable to a specific hour of the
     * day if clicked
     *
     * @param boolean invisibleEvents Set to true if we have invisible events to scroll to and false if not
     * @param string  linkId          The ID of the link we are going to add to the page
     * @param int     scrollThreshold The scroll threshold used to fade out the link
     * @param int     scrollLimit     The pixel value to scroll to when the 'go to' link is clicked
     * @param string  direction       An string indicating the direction of scrolling
     *
     * @returns {undefined}
     */
    function handleGoToLink(invisibleEvents, linkId, scrollThreshold, scrollLimit, direction) {
        // Handle the scrolling for an invisible events that won't be immediately visible
        if (invisibleEvents === false) {
            // Remove any scrolling overlays we might have in place
            $('#' + linkId).remove();
        } else if (!$('#' + linkId).length) {
            // Add a scroll to link to the content div
            $('.timetable-content-row').append('<div id="' + linkId + '"><a href="javascript:void(0)"><i class="' + FontAwesome.prefix('solid', 'angle-double-' + direction) + ' fa-5x"></i></a></div>');

            // Bind a click event to the link to scroll the timetable
            $('#' + linkId + ' a').on('click', function (e) {
                e.preventDefault();

                $('.timetable-content-row').slimScroll({
                    scrollTo: scrollLimit + 'px',
                });
            });

            // Bind a slimscroll event to report the position of the scroll bar
            $('.timetable-content-row').slimScroll().on('slimscrolling', function (e, pos) {
                if (direction === 'up') {
                    // Show the scroll to top button if we haven't yet gone up
                    if (pos < scrollThreshold) {
                        // Hide the scroll to top button
                        $('#' + linkId).fadeOut(500);
                    } else {
                        // Show the scroll to top button
                        $('#' + linkId).fadeIn(500);
                    }
                } else {
                    // Show the scroll to top button if we haven't yet gone up
                    if (pos > scrollThreshold) {
                        // Hide the scroll to top button
                        $('#' + linkId).fadeOut(500);
                    } else {
                        // Show the scroll to top button
                        $('#' + linkId).fadeIn(500);
                    }
                }
            });
        }
    }

    /**
     * Return the start date of week one for a given month, based on the calendar start date
     *
     * @param  string  calendarStart
     * @param  integer month
     * @return dayjs
     */
    function getDateOfWeekOne(calendarStart, month) {
        const year        = calendarStart.format('YYYY');
        const paddedMonth = month < 10 ? '0' + month : month; // Add leading 0

        var weekOneStart = getWeekOneStart(year, paddedMonth);

        // Use the previous year if Week 1 starts after the calendar date
        if (weekOneStart.isAfter(calendarStart)) {
            weekOneStart = getWeekOneStart(year - 1, paddedMonth);
        }

        return weekOneStart;
    }

    /**
     * Calculate the start date of week one for a given year
     *
     * @param  integer year
     * @param  string  paddedMonth
     * @return dayjs
     */
    function getWeekOneStart(year, paddedMonth) {
        // Academic calendar override: Week 1 for 2026/27 starts 27 July 2026.
        // This differs from the historical rule where a Saturday 1 August
        // Resulted in the following Monday being Week 1 (e.g. 2015).
        const academicWeekOneOverrides = {
            2026: '2026-07-27',
        };

        if (Object.hasOwn(academicWeekOneOverrides, year)) {
            return dayjs(academicWeekOneOverrides[year]);
        }

        const firstOfMonth = dayjs(year + '-' + paddedMonth + '-01');

        var weekOneStart = firstOfMonth.clone().day(1); // Monday

        // If the 1st lands on a weekend
        if (firstOfMonth.weekday() >= 6) {
            weekOneStart = weekOneStart.add(1, 'week');
        }

        return weekOneStart;
    }

    /**
     * Sets the date output in the header area
     *
     * @returns {undefined}
     */
    function renderHeaderText() {
        var headerText = '';

        // Check if this is the same month
        if (dayjs(settings.startdt).isSame(dayjs(settings.enddt), 'month')) {
            // Contained within same month
            headerText = dayjs(settings.startdt).format('D') + '-' + dayjs(settings.enddt).format('D MMMM YYYY');
        } else {
            // Span a month - does it span year
            if (dayjs(settings.startdt).isSame(dayjs(settings.enddt), 'year')) {
                // Same year, just show diff months
                headerText = dayjs(settings.startdt).format('D MMMM') + ' - ' + dayjs(settings.enddt).format('D MMMM YYYY');
            } else {
                // All different, show everything
                headerText = dayjs(settings.startdt).format('D MMMM YYYY') + ' - ' + dayjs(settings.enddt).format('D MMMM YYYY');
            }
        }

        var weekOneStart = getDateOfWeekOne(settings.startdt, settings.weekOneMonth);
        var weekNumber   = Math.abs(weekOneStart.diff(settings.startdt, 'week')) + 1;
        var degreeYear   = settings.dpy > 0 ? ' Programme Year ' + settings.dpy : '';

        headerText = 'UoA Week ' + weekNumber + ' - ' + headerText + degreeYear;

        $('#' + settings.idprefix + '-header-text').text(headerText);
    }

    /**
     * Render the day header text for the week
     *
     * @returns {undefined}
     */
    function renderDayHeaderText() {
        for (var d = 0; d < settings.daysdisplayed; d++) {
            var elem = $('#' + settings.idprefix + '-day-' + d);

            if (elem) {
                var drawday = dayjs(settings.startdt).add(d, 'day');

                // Remove existing "today" class if currently added
                elem.removeClass('today');

                // Is the day we are drawing the same as today?
                if (dayjs().isSame(drawday, 'day')) {
                    elem.addClass('today');
                }

                elem.text(drawday.format(settings.daydateformat));
            }
        }
    }

    /**
     * Move forwards or backwards in time a given number of days
     *
     * @param {int} amount number of days to move forward
     *
     * @returns {undefined}
     */
    function move(amount) {
        // Remove all existing events
        $('.timetable-event').remove();
        $('.all-day-event').remove();

        // Change the date range
        settings.startdt = dayjs(settings.startdt).add(amount, 'day');
        settings.enddt = dayjs(settings.enddt).add(amount, 'day');

        // Re-render the header
        renderHeaderText();

        // Re-render the day headers
        renderDayHeaderText();

        // Is this within our data range
        if (settings.startdt < settings.datastart || settings.startdt > settings.dataend || settings.enddt > settings.dataend) {
            // Need to request new data - take the new data and select 1 month before and after
            var newdatastart = dayjs(settings.startdt).subtract(1, 'month');
            var newdataend   = dayjs(settings.enddt).add(1, 'month');

            settings.datastart = newdatastart,
            settings.dataend   = newdataend;

            var requesturl = settings.templateurl.replace('%%DPY%%', settings.dpy)
                .replace('%%START%%', dayjs(newdatastart).format('X'))
                .replace('%%END%%', dayjs(newdataend).format('X'))
                .replace('%%UID%%', settings.uid ? settings.uid : '');
            // Request the data and draw it
            loaddata(requesturl);
        } else {
            // We have the data, just draw it
            drawEvents();
        }
    }

    /**
     * Draw the loaded events on the timetable
     *
     * @returns {undefined}
     */
    function drawEvents() {
        // Define temp container for events and special events
        var eventstodraw        = [];
        var morningEvents       = false;
        var eveningEvents       = false;

        // Initialise (or re-init) the timeblocks
        _initialisetimeblocks();

        // Do we have events
        if (settings.events && $.isArray(settings.events)) {
            // For each event
            $.each(settings.events, function (idx, event) {
                if (dayjs.unix(event.start).isSame(settings.startdt, 'week')) {
                    // Set the start hour for the event
                    var startHour = dayjs.unix(this.start).hour();

                    // Check if the event we are going to draw is pre 9am
                    if (startHour < 9) {
                        // Set morning events to true
                        morningEvents = true;
                    }

                    // Check if the event is post 5pm
                    if (startHour > 17) {
                        // Set evening events to true
                        eveningEvents = true;
                    }

                    // Add the event to the drawing list
                    eventstodraw.push(event);
                    // Prepare the timeblock times and add it to the timeblock accordingly
                    prepTimeblockData(event);
                }
            });
        }

        // Handle the rendering of a link to skip to the top of the timetable
        handleGoToLink(morningEvents, 'scrollToTop', 380, 0, 'up');

        // Handle the rendering of a link to skip to the bottom of the timetable
        handleGoToLink(eveningEvents, 'scrollToBottom', 680, 1380, 'down');

        // Handle the rendering of events and categories
        var alltagsthisweek = [];
        $('.timetable-categories').html('<i class="' + FontAwesome.prefix('solid', 'tags') + '"></i> None');
        if (eventstodraw.length > 0) {
            $.each(eventstodraw, function (idx, event) {
                // If we have tags for the event (categories) add them to array 'alltagsthisweek'
                if (event.tags) {
                    $.each(event.tags, function (idx, tag) {
                        if (alltagsthisweek.includes(tag.tagname) === false) {
                            alltagsthisweek.push(tag.tagname);
                        }
                    });
                    // Update header area with categories for this week
                    $('.timetable-categories').html('<i class="' + FontAwesome.prefix('solid', 'tags') + '"></i> ' + alltagsthisweek.join(', '));
                }
                // Prepare the rending of single event
                prepareEvent(event);
            });
        }

        // Finally if we have a click action, bind it
        if (settings.onClick !== null) {
            $('.timetable-event').bind('click', function (e) {
                settings.onClick($(this).data('event'));
            });
        }

        // Toggle visibility of loading screen (hide it!)
        _toggleLoader('hide');
    }

    /**
     * This function prepares an event for rendering. It calculates the number of days that an event spans
     * across. Given this information, the function then renders the event
     *
     * @param {object} event An object containing the event data
     *
     * @returns {undefined}
     */
    function prepareEvent(event) {
        // Calculate the starting and ending times as moments
        var mstart = dayjs.unix(event.start);
        var mend   = dayjs.unix(event.end);

        // Render the event
        renderEventDiv(event);
    }

    /**
     * This function is used to merge an existing map for a row of all day events to a newly calculated event map for an
     * individual all day event
     *
     * @param {Array} existingRowMap An array containing positioning information for an existing row
     * @param {Array} newEventMap    An array containing positioning information for a single event map
     *
     * @returns {Array} Returns the existing row map merged with the individual event mapping
     */
    function mergeEventMaps(existingRowMap, newEventMap) {
        // Iterate through the new event map
        for (var i = 0; i < newEventMap.length; i++) {
            // Check to see if we have an event stored in the day slot
            if (newEventMap[i] instanceof Array) {
                // Store this array in the existing row
                existingRowMap[i] = newEventMap[i];
            }
        }

        // Return the modified row mapping
        return existingRowMap;
    }

    /**
     * This function renders an event in the timetable
     *
     * @param {object} event This is an event object which contains all event data
     *
     * @returns {undefined}
     */
    function renderEventDiv(event) {
        // Calculate the starting and ending times as moments
        var mstart   = dayjs.unix(event.start).tz('Europe/London');
        var mend     = dayjs.unix(event.end).tz('Europe/London');

        // Calculate the day start and day
        var daystart = mstart.hour(settings.daystart).minute(0);
        var day      = mstart.day();

        // Work out minute:pixel values
        var minpix = settings.timeblockheight / settings.gridincrements;

        // Work out the duration of the event in minutes
        var duration = mend.diff(mstart, 'minute');

        // Calculate the height - trim 1 to contain within grid
        var height = minpix * duration - 1;

        // Find how many events are running concurrently
        var numconcurrent = numconcurrentevents(event);

        // Calculate the width
        var width = 100 / numconcurrent;

        // Calculate the column position
        var column = 0;

        // We need to find the number of concurrent drawn events
        var drawnsofar = numconcurrentevents(event);

        // If we have one or more events that coincide with the event we are trying to draw, get the column count
        if (drawnsofar > 0) {
            column = getColumnCount(event, day, numconcurrent);
        }

        var left = width * column;

        // Calculate the top position - add 1 to pad so lines appear
        var top = 1 + minpix * mstart.diff(daystart, 'minute');

        // Restrict the top of the events to be within the confines of the calendar grid
        if (top < 1) {
            height += top;
            top = 1;
        }

        // Restrict the height to the calendar maximum
        var calHeight = settings.timeblockheight * (settings.dayend - settings.daystart + 1);
        if (height > calHeight) {
            height = calHeight - top;
        }

        // Calculate the day column
        var dayidx = mstart.day() - settings.weekstart;

        // Grab the data for the location & lecturers
        var locations = '';

        if (event.locations !== undefined && _.size(event.locations) > 0) {
            if (_.size(event.locations) > 1) {
                locations = 'Multiple Locations';
            } else {
                var location = event.locations[Object.keys(event.locations)[0]];
                locations = location.postcode ? location.room + ', ' + location.building : location.name;
            }
        }

        var lecturers = '';
        if (event.tutors !== undefined && _.size(event.tutors) > 0) {
            if (_.size(event.tutors) > 1) {
                lecturers = 'Multiple Lecturers';
            } else {
                var tutor = event.tutors[Object.keys(event.tutors)[0]];
                lecturers = tutor.title + ' ' + tutor.firstname[0].toUpperCase() + '. ' + tutor.lastname;
            }
        }

        // Do we need to flag this event?
        var desc = '';
        if (event.description !== '') {
            desc = '<i class="' + FontAwesome.prefix('regular', 'flag') + '" title="Description Has Been Set"></i> ';
        }

        var resourceflag = '';
        if (!$.isEmptyObject(event.resources)) {
            resourceflag = '<i class="' + FontAwesome.prefix('solid', 'paperclip') + '" title="Resources Available"></i> ';
        }

        // Initialise variables to store the concatenated groups string and another to count number of groups
        var groupsStr = '';
        var groupCnt = 0;

        // Loop all groups and compile group string and increment the count
        $.each(event.attendees, function (index, value) {
            groupsStr += value.a_name + ', ';
            groupCnt++;
        });

        // Remove the trailing comma and blank space from the title
        var groupsTitle = groupsStr.slice(0, -2);

        // Add icon to specify whether the event is a single group or multi-group teaching event
        var groups = '<i class="' + FontAwesome.prefix('regular', 'user') + '" title="' + groupsTitle + '"></i> ';
        if (event.attendees === undefined) {
            groups = '';
        } else if (groupCnt > 1) {
            groups = '<i class="' + FontAwesome.prefix('solid', 'users') + '" title="' + groupsTitle + '"></i> ';
        }

        var shared = '';
        if (!isNaN(parseFloat(event.se_id)) && isFinite(event.se_id)) {
            shared = '<i class="' + FontAwesome.prefix('solid', 'link') + '" title="' + event.s_title + ' shared event"></i> ';
        }

        var cancelled = event.cancelled == 1
            ? ' [CANCELLED]'
            : '';

        var overflowLocation = event.overflow_id > 0
            ? ' <i class="' + FontAwesome.prefix('solid', 'location-arrow') + '" title="This event has an overflow location. Click for more details"></i>'
            : '';

        var live = '';
        var facetoface = '';
        $.each(event.tags, function (idx, tag) {
            if (tag.tagname === 'Live') {
                live = true;
            }
            if (tag.tagname === 'Face to Face') {
                facetoface = true;
            }
        });

        // Add to the container
        $('#timetable-day-event-column-' + dayidx).append('<div id="event-' + event.id + '" title="' + event.title + cancelled + ($.isEmptyObject(event.resources) ? '' : ' - Resources Available') +
            '" class="timetable-event' + (event.cancelled == 1 ? ' cancelled' : '') + (live ? ' live' : '') + (facetoface ? ' facetoface' : '') +
            '" style="height: ' + height + 'px; top: ' + top + 'px; width: ' + width + '%; left: ' + left + '%">' +
            '<p class="event-title">' + desc + resourceflag + groups + shared + event.title + cancelled + '</p>' +
            '<div class="event-details">' +
            '<p class="event-location">' + locations + overflowLocation + '</p>' +
            '<p class="event-lecturer">' + lecturers + '</p>' +
            '</div>' +
            '</div>');

        // Add data to this component
        $('#event-' + event.id).data('event', event);

        // Mark this event as drawn and set the timeblocks this event spans in 5 minute increments
        var unixstart = parseInt(event.start);
        var unixend = parseInt(event.end);
        for (var tnow = unixstart; tnow < unixend; tnow += 300) {
            var mtnow = dayjs.unix(tnow);
            var hours = mtnow.hour();
            var mins  = mtnow.minute();

            drawntimeblocks[day][hours][mins] += 1;
            drawntimeblockscols[day][hours][mins].push(column);
        }
    }

    /**
     * Set the timeblocks array to a new blank array
     *
     * @returns {undefined}
     */
    function _initialisetimeblocks() {
        eventtimeblockspans = [];
        drawntimeblocks     = [];
        drawntimeblockscols = [];

        // Initalise the days
        for (var d = 0; d <= 7; d++) {
            // Create blank day array
            eventtimeblockspans[d] = [];
            drawntimeblocks[d]     = [];
            drawntimeblockscols[d] = [];

            // Initialise the hours
            for (var h = 0; h < 24; h++) {
                // Create blank day-hour array
                eventtimeblockspans[d][h] = [];
                drawntimeblocks[d][h]     = [];
                drawntimeblockscols[d][h] = [];

                // Initialise the minutes (in 5 minute blocks)
                for (var m = 0; m < 60; m += 5) {
                    eventtimeblockspans[d][h][m] = 0;
                    drawntimeblocks[d][h][m]     = 0;
                    drawntimeblockscols[d][h][m] = [];
                }
            }
        }
    }

    /**
     * This function is used for preparing times and adding to the timeblock
     * once created
     *
     * @param {object} event A single event object
     *
     * @returns {undefined}
     */
    function prepTimeblockData(event) {
        // Grab start and end hours
        var start     = dayjs.unix(event.start);
        var end       = dayjs.unix(event.end);

        // Get the current day
        var day = start.day();

        // Only add to the timeblock if the event is NOT an all day event
        if (end.diff(start, 'minute') < 1439) {
            // This is not an all day event, add it to the timeblock

            // Set the timeblocks this event spans in 5 minute increments
            var unixstart = parseInt(event.start);
            var unixend = parseInt(event.end);
            for (var tnow = unixstart; tnow < unixend; tnow += 300) {
                var mtnow = dayjs.unix(tnow);
                _addtotimeblock(day, mtnow.hour(), mtnow.minute());
            }
        }
    }

    /**
     * Add to the timeblock
     *
     * @param {int} day     the day of this event
     * @param {int} hour    the hour of this event
     * @param {int} minutes the minutes of this event
     *
     * @returns {undefined}
     */
    function _addtotimeblock(day, hour, minutes) {
        if (eventtimeblockspans !== null && hour !== undefined && minutes !== undefined) {
            // Update existing value - add one
            eventtimeblockspans[day][hour][minutes] += 1;
        }
    }

    /**
     * Check how many concurrent events are occurring at specified date/time
     *
     * @param {object} event the event object to check
     *
     * @returns {int} the maximum number of concurrent events
     */
    function numconcurrentevents(event) {
        // Grab start hours
        var start = dayjs.unix(event.start);

        // Get the current day
        var day = start.day();

        // Set the max concurrent
        var maxconcurrent = 1;

        // Grab unix times
        var unixstart = parseInt(event.start);
        var unixend = parseInt(event.end);
        for (var tnow = unixstart; tnow < unixend; tnow += 300) {
            var mtnow = dayjs.unix(tnow);

            if (eventtimeblockspans[day][mtnow.hour()][mtnow.minute()] > maxconcurrent) {
                maxconcurrent = eventtimeblockspans[day][mtnow.hour()][mtnow.minute()];
            }
        }

        return maxconcurrent;
    }

    /**
     * This function is used to get the column index for a column we are about to render in the timetable
     *
     * @param {Object} event         An object storing information about the event we are going to render
     * @param {int}    day           An index number identifying which day the event takes place on
     * @param {int}    numConcurrent The total number of concurrent events (not necessarily drawn)
     *
     * @returns {int} Returns the column index to position the event in the timetable
     */
    function getColumnCount(event, day, numConcurrent) {
        // Define a variable to track the column count
        var column = 0;

        // Grab unix times
        var unixstart = parseInt(event.start);
        var unixend = parseInt(event.end);

        // We need to cycle through the duration of the event to find the maximum column width
        for (var tnow = unixstart; tnow < unixend; tnow += 300) {
            var now = dayjs.unix(tnow);

            while (drawntimeblockscols[day][now.hour()][now.minute()].includes(column)) {
                // Incremement the column count
                column = (column + 1) % numConcurrent;
            }
        }

        // Return the column value
        return column;
    }

    /**
     * Toggles the "Loading" spinner and overlay depending on the value of `mode`
     *
     * @param   {string} mode A string indicating whether or not to show the loading overlay
     * @returns {undefined}
     */
    function _toggleLoader(mode) {
        if (mode === 'show') {
            $('#' + settings.idprefix + '-loader').removeClass('hide');
        } else {
            $('#' + settings.idprefix + '-loader').addClass('hide');
        }
    }
})(jQuery);
